export enum TaskPriority {
    Low = 0,
    Medium = 1,
    High = 2
}
